/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./src/js/app.js":
/*!***********************!*\
  !*** ./src/js/app.js ***!
  \***********************/
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
document.addEventListener("DOMContentLoaded", function () {
  (function () {
    var button = document.getElementById("headerShopButton");
    var closeProductsPopup = document.getElementById("closeProductsPopup");
    var popup = document.getElementById("shopButtonPopup");
    var popupMenu = document.getElementById("popUpMenu");
    var navButtons = document.getElementById("navButtons");
    // const productNavWidget = document.getElementById("product-nav-widget");
    var cartDrawer = document.querySelector("cart-drawer");
    var cartButton = document.getElementById("cartButton");
    var PATCH_TRIGGER_LOADING_CLASS = "patch-trigger--loading";
    function refreshPatchTriggerLabel(variantId) {
      if (!variantId || typeof window.PatchesManager === "undefined" || typeof window.PatchesManager.getSelectionCount !== "function" || typeof window.PatchesManager.updateTriggerButtonLabel !== "function") {
        return;
      }
      var count = window.PatchesManager.getSelectionCount(variantId);
      window.PatchesManager.updateTriggerButtonLabel(variantId, count);
    }
    function setPatchTriggersLoading(isLoading) {
      var buttons = document.querySelectorAll("[data-patch-trigger]");
      if (!buttons || buttons.length === 0) return;
      buttons.forEach(function (buttonEl) {
        var label = buttonEl.querySelector("[data-patch-button-label]");
        if (isLoading) {
          buttonEl.disabled = true;
          buttonEl.classList.add(PATCH_TRIGGER_LOADING_CLASS);
          if (label) {
            if (!buttonEl.dataset.patchOriginalLabel) {
              buttonEl.dataset.patchOriginalLabel = label.textContent.trim();
            }
            label.textContent = "Loading...";
          }
        } else {
          buttonEl.classList.remove(PATCH_TRIGGER_LOADING_CLASS);
          buttonEl.disabled = false;
          if (label && label.textContent.trim() === "Loading..." && buttonEl.dataset.patchOriginalLabel) {
            label.textContent = buttonEl.dataset.patchOriginalLabel;
          }
          delete buttonEl.dataset.patchOriginalLabel;
        }
      });
    }
    var hasPatchTriggers = document.querySelector("[data-patch-trigger]") !== null;
    if (hasPatchTriggers) {
      setPatchTriggersLoading(true);
      document.addEventListener("patches-manager:ready", function () {
        setPatchTriggersLoading(false);
        if (typeof window.PatchesManager !== "undefined" && typeof window.PatchesManager.restoreTriggerButtonLabel === "function") {
          window.PatchesManager.restoreTriggerButtonLabel();
        }
      });
      if (window.PatchesManagerReady === true) {
        setPatchTriggersLoading(false);
        if (typeof window.PatchesManager !== "undefined" && typeof window.PatchesManager.restoreTriggerButtonLabel === "function") {
          window.PatchesManager.restoreTriggerButtonLabel();
        }
      }
    }

    //let originalStyle = "";

    // manage scroll-stopping
    function toggleScrollLock(lock) {
      if (lock) {
        document.body.classList.add("stop-scrolling");
      } else {
        document.body.classList.remove("stop-scrolling");
      }
    }
    button.addEventListener("click", function () {
      var isOpen = this.classList.toggle("open-shop-nav");
      if (isOpen) {
        //close cart drawer if it's open
        if (cartDrawer !== null && cartDrawer !== void 0 && cartDrawer.classList.contains("active")) {
          cartDrawer.close();
        }
        openPopup();
      } else {
        closePopup();
      }
    });
    // manage state of productNavWidget when popups appear
    function updateProductNavWidget(isPopupOpen) {
      // Ensure productNavWidget is defined before proceeding
      var productNavWidget = document.querySelector("#product-nav-widget");
      if (!productNavWidget) return; // Exit if productNavWidget does not exist on the page

      // Check if productNavWidget is visible using its inline style values
      var isVisible = productNavWidget.style.visibility === "visible" && productNavWidget.style.opacity === "1";
      if (isPopupOpen) {
        // Hide the widget only if it is currently visible
        if (isVisible) {
          // Cache original styles if not already cached
          if (!productNavWidget.dataset.originalStyle) {
            productNavWidget.dataset.originalStyle = productNavWidget.style.cssText;
          }
          productNavWidget.style.visibility = "hidden";
          productNavWidget.style.opacity = "0";
        }
      } else {
        navButtons.classList.remove("no-bg");
        // Restore the widget's original styles if it was hidden due to the popup
        if (productNavWidget.dataset.originalStyle) {
          productNavWidget.style.cssText = productNavWidget.dataset.originalStyle;
          productNavWidget.dataset.originalStyle = "";
        } else if (isVisible) {
          productNavWidget.style.visibility = "visible";
          productNavWidget.style.opacity = "1";
        }
      }
    }
    window.updateProductNavWidget = updateProductNavWidget; //expose to global scope

    closeProductsPopup.addEventListener("click", closePopup);
    function openPopup() {
      var _popup$querySelector;
      popup.classList.add("open-popup");
      popupMenu.classList.add("visible");
      navButtons.classList.add("no-bg");
      button.setAttribute("aria-expanded", "true");
      toggleScrollLock(true); // Disable scrolling

      // Update productNavWidget state
      updateProductNavWidget(true);

      // Set focus to the first button inside the popup, if it exists
      (_popup$querySelector = popup.querySelector("button")) === null || _popup$querySelector === void 0 || _popup$querySelector.focus();
    }
    function closePopup() {
      button.classList.remove("open-shop-nav");
      popup.classList.remove("open-popup");
      popupMenu.classList.remove("visible");
      navButtons.classList.remove("no-bg");
      button.setAttribute("aria-expanded", "false");
      toggleScrollLock(false); // Enable scrolling

      // Update productNavWidget state
      updateProductNavWidget(false);
    }

    // Variant Customization Popup and Quick Cart drawer related code

    var currentProduct = null;

    // open the variant popup and fetch product data
    function openVariantPopup(productHandle, selectedVariantId) {
      if (!productHandle) {
        console.error("Invalid product handle");
        return;
      }
      var url = "/products/".concat(productHandle, ".js");
      fetch(url).then(function (response) {
        if (!response.ok) {
          throw new Error("HTTP error! status: ".concat(response.status));
        }
        return response.json();
      }).then(function (product) {
        currentProduct = product; // Set currentProduct here
        renderPopupContent(product, selectedVariantId);
        document.getElementById("variant-popup").style.display = "block";
        trapFocus("variant-popup");

        // Set product price
        var selectedVariant = product.variants.length > 0 ? product.variants.find(function (variant) {
          return variant.id.toString() === selectedVariantId;
        }) || product.variants[0] : product;
        document.getElementById("product-price").textContent = formatMoney(selectedVariant.price);

        // Set color select and label only if variants exist
        if (product.variants.length > 0 && selectedVariant.option1) {
          var colorLabel = document.querySelector(".variant-color-label");
          var colorSelect = document.querySelector(".custom-select-wrapper.custom-select-color .custom-select-label");
          colorLabel.textContent = selectedVariant.option1;
          colorSelect.textContent = selectedVariant.option1;
        }
      })["catch"](function (error) {
        console.error("Error fetching product data:", error);
        alert("Sorry, there was an error loading the product. Please try again.");
      });
    }

    // render the popup content with product details
    function renderPopupContent(product, selectedVariantId) {
      var _selectedVariant$feat;
      var popupContent = document.getElementById("popup-product-details");

      // Find the selected variant or default to the first variant
      var selectedVariant = product.variants.find(function (variant) {
        return variant.id.toString() === selectedVariantId;
      }) || product.variants[0];
      var options = product.options || [];
      var hasOption1 = options.length > 0 && options[0].values.length > 1;
      var hasOption2 = options.length > 1 && options[1].values.length > 1;
      var colorLabel = selectedVariant.option1 || "--";
      var sizeLabel = selectedVariant.option2 || "--";

      // HTML template for the popup content
      var html = "\n<div class=\"variant-popup-container\">\n  <div class=\"vpc--wrapper\">\n    <div class=\"vpc--left-column\">\n      <img src=\"".concat(((_selectedVariant$feat = selectedVariant.featured_image) === null || _selectedVariant$feat === void 0 ? void 0 : _selectedVariant$feat.src) || product.featured_image, "\" alt=\"").concat(product.title, "\" class=\"product-image\" />\n    </div>\n    <div class=\"vpc---right-column\">\n      <h2 class=\"product-title\">").concat(product.title, "</h2>\n      <p id=\"product-price\" class=\"product-price\">").concat(selectedVariant.available ? formatMoney(selectedVariant.price) : "Variant not available", "</p>\n      <div class=\"variant-label-wrapper d-eyebrow\">\n        <div class=\"variant-label\">\n          <span class=\"variant-label-label\">COLOR:</span>  ").concat(hasOption1 ? "<span class=\"variant-color-label\">".concat(colorLabel, "</span>") : "--", "\n        </div>\n        <div class=\"variant-label\">\n          <span class=\"variant-label-label\">SIZE:</span> <span class=\"variant-size-label\">--</span>\n        </div>\n      </div>\n    </div>\n    </div>\n      <div id=\"variant-selectors\" class=\"variant-selectors\"></div>\n        <button id=\"addToCart\" type=\"button\" class=\"button-primary add-to-cart-button\" data-variant-id=\"\" disabled>\n          <span class=\"button-text\">Add to Cart</span>\n          <span class=\"button-icon ico-base ico-16 ico16-plus-black\"></span> \n          <div class=\"loading-spinner\">\n            <svg  aria-hidden=\"true\" focusable=\"false\" viewBox=\"0 0 800 800\" xmlns=\"http://www.w3.org/2000/svg\">\n              <circle class=\"spin\" cx=\"400\" cy=\"400\" fill=\"none\" r=\"200\" stroke-width=\"50\" stroke=\"#7c7c7c\" stroke-dasharray=\"387 1400\" stroke-linecap=\"round\" />\n            </svg>\n          </div>\n       </button> \n      </div>\n      ");
      popupContent.innerHTML = html;

      // Attach event listener to close button
      document.getElementById("closeVariantPopup").addEventListener("click", function () {
        document.getElementById("variant-popup").style.display = "none";
        toggleScrollLock(false);
      });

      // Populate the variant selectors (e.g., color and size dropdowns)
      populateVariantSelectors(product, selectedVariantId);
      // Get the initially selected color
      var initialColor = document.querySelector(".custom-select-wrapper.custom-select-color .custom-select-label").textContent;

      // Update size options based on the initially selected color
      updateSizeOptions(initialColor);
      // Set initial state of Add to Cart button
      updateSelectedVariant();
    }

    // Color mappings for the color swatches
    var colorMappings = {
      "Stratus Silver": "#D3D3D3",
      Bahama: "#00AFD0",
      "Two Blue": "#385988",
      "Ocean Blue": "#3C6E89",
      "Red Blue": "#CB4F53",
      Harvest: "#B46547",
      Black: "#474747",
      "Rusty Slate": "#C97146",
      "Ice Blue": "#6899AE",
      Sand: "#C7AF87",
      "Army Green": "#777A61",
      "Mountain Blue": "#385988",
      "Gray Black": "#9D9F99",
      "Orange Charcoal": "#F6A04D",
      "Blue Ridge": "#375172"
    };

    // Function to update the selected variant based on user selection

    function updateSelectedVariant() {
      var colorSelect = document.querySelector(".custom-select-wrapper.custom-select-color .custom-select-label").textContent;
      var sizeSelect = document.querySelector(".custom-select-wrapper.custom-select-size .custom-select-label").textContent;
      var addToCartButton = document.querySelector(".add-to-cart-button");
      var productImage = document.querySelector(".product-image");

      // Find the selected variant
      var selectedVariant = currentProduct.variants.find(function (variant) {
        return variant.option1 === colorSelect && variant.option2 === sizeSelect;
      });
      if (selectedVariant && sizeSelect !== "Select Size") {
        // Update price
        document.getElementById("product-price").textContent = formatMoney(selectedVariant.price);

        // Update Add to Cart button
        addToCartButton.dataset.variantId = selectedVariant.id;
        addToCartButton.disabled = false;

        // Keep patch trigger variant context in sync with selected variant
        var patchTrigger = document.querySelector("[data-patch-trigger=\"true\"][data-product-id=\"".concat(currentProduct.id, "\"]"));
        if (patchTrigger) {
          patchTrigger.dataset.variantId = selectedVariant.id;
          refreshPatchTriggerLabel(selectedVariant.id);
        }

        // Update product image
        if (productImage) {
          var _selectedVariant$feat2;
          productImage.src = ((_selectedVariant$feat2 = selectedVariant.featured_image) === null || _selectedVariant$feat2 === void 0 ? void 0 : _selectedVariant$feat2.src) || currentProduct.featured_image;
          productImage.alt = currentProduct.title;
        }
      } else {
        // Disable Add to Cart button if no size is selected or variant not found
        addToCartButton.disabled = true;
        addToCartButton.dataset.variantId = "";
        var _patchTrigger = document.querySelector("[data-patch-trigger=\"true\"][data-product-id=\"".concat(currentProduct.id, "\"]"));
        if (_patchTrigger) {
          _patchTrigger.dataset.variantId = "";
        }
      }

      // Update color label
      var colorLabel = document.querySelector(".variant-color-label");
      if (colorLabel) {
        colorLabel.textContent = colorSelect;
      }

      // Update size label
      var sizeLabel = document.querySelector(".variant-size-label");
      if (sizeLabel && sizeSelect !== "Select Size") {
        sizeLabel.textContent = sizeSelect;
        sizeLabel.classList.remove("crossed");
      }
    }

    // Function to format the price as currency
    function formatMoney(cents) {
      return "$" + (cents / 100).toFixed(0);
    }

    // Function to populate the variant selectors (e.g., color and size)

    function populateVariantSelectors(product, selectedVariantId) {
      var variantSelectorsElement = document.getElementById("variant-selectors");
      variantSelectorsElement.innerHTML = ""; // Clear existing selectors

      if (product.variants.length === 0) {
        return;
      }
      if (Array.isArray(product.options)) {
        product.options.forEach(function (option, index) {
          var optionName = option.name || option;
          var uniqueValues = _toConsumableArray(new Set(product.variants.map(function (variant) {
            return variant.options[index] || "";
          })));
          if (uniqueValues.length > 1) {
            var customSelectWrapper = document.createElement("div");
            customSelectWrapper.className = "custom-select-wrapper custom-select-".concat(optionName.toLowerCase());
            var label = document.createElement("div");
            label.className = "custom-select-label";
            label.textContent = optionName.toLowerCase() === "size" ? "Select ".concat(optionName) : "";
            customSelectWrapper.appendChild(label);
            var dropdownList = document.createElement("div");
            dropdownList.className = "custom-select-dropdown";
            uniqueValues.forEach(function (value) {
              var variantsWithThisValue = product.variants.filter(function (variant) {
                return variant.options[index] === value;
              });
              var isAvailable = variantsWithThisValue.some(function (variant) {
                return variant.available;
              });
              var listItem = document.createElement("div");
              listItem.className = "custom-select-item".concat(isAvailable ? "" : " disabled-variant");
              listItem.textContent = value + (isAvailable ? "" : " (Out of Stock)");
              listItem.dataset.value = value;
              if (optionName.toLowerCase() === "color" && colorMappings[value]) {
                var swatch = document.createElement("span");
                swatch.className = "color-swatch";
                swatch.style.backgroundColor = colorMappings[value];
                listItem.prepend(swatch);
              }
              listItem.addEventListener("click", function () {
                if (isAvailable) {
                  label.textContent = value;
                  dropdownList.classList.remove("open");
                  if (optionName.toLowerCase() === "color") {
                    updateSizeOptions(value);
                    // Find the first available variant for this color
                    var firstAvailableVariant = product.variants.find(function (v) {
                      return v.option1 === value && v.available;
                    });
                    if (firstAvailableVariant) {
                      var productImage = document.querySelector(".product-image");
                      if (productImage) {
                        var _firstAvailableVarian;
                        productImage.src = ((_firstAvailableVarian = firstAvailableVariant.featured_image) === null || _firstAvailableVarian === void 0 ? void 0 : _firstAvailableVarian.src) || product.featured_image;
                        productImage.alt = product.title;
                      }
                    }
                  }
                  updateSelectedVariant();
                }
              });
              dropdownList.appendChild(listItem);
            });
            label.addEventListener("click", function () {
              dropdownList.classList.toggle("open");
            });
            customSelectWrapper.appendChild(dropdownList);
            variantSelectorsElement.appendChild(customSelectWrapper);

            // Set initial color based on the selected variant
            if (optionName.toLowerCase() === "color") {
              var selectedVariant = product.variants.find(function (v) {
                return v.id.toString() === selectedVariantId;
              });
              if (selectedVariant) {
                label.textContent = selectedVariant.option1;
              }
            }
          }
        });
      } else {
        console.error("Product options are not defined or not an array");
      }
      updateSelectedVariant();
    }

    // Function to update the size options based on the selected color
    function updateSizeOptions(selectedColor) {
      var sizeSelect = document.querySelector(".custom-select-size .custom-select-label");
      var dropdownList = document.querySelector(".custom-select-size .custom-select-dropdown");
      var variantSizeLabel = document.querySelector(".variant-size-label");
      if (!dropdownList) return; // Exit if size dropdown doesn't exist

      dropdownList.innerHTML = ""; // Clear existing options

      // Filter variants based on the selected color
      var relevantVariants = currentProduct.variants.filter(function (variant) {
        return variant.option1 === selectedColor;
      });

      // Get unique sizes
      var uniqueSizes = _toConsumableArray(new Set(relevantVariants.map(function (variant) {
        return variant.option2;
      })));

      // Get the previously selected size
      var previouslySelectedSize = sizeSelect.textContent !== "Select Size" ? sizeSelect.textContent : null;

      // Add each size as an item in the dropdown list
      uniqueSizes.forEach(function (size) {
        var isAvailable = relevantVariants.some(function (variant) {
          return variant.option2 === size && variant.available;
        });
        var listItem = document.createElement("div");
        listItem.className = "custom-select-item".concat(isAvailable ? "" : " disabled-variant");
        listItem.textContent = size + (isAvailable ? "" : " (Out of Stock)");
        listItem.dataset.value = size;

        // Handle clicking on an item to update the selection
        listItem.addEventListener("click", function () {
          if (isAvailable) {
            sizeSelect.textContent = size;
            variantSizeLabel.textContent = size;
            variantSizeLabel.classList.remove("crossed");
            dropdownList.classList.remove("open");
            updateSelectedVariant();
          }
        });
        dropdownList.appendChild(listItem);
      });

      // Check if the previously selected size is available for the new color
      if (previouslySelectedSize) {
        var isSizeAvailable = relevantVariants.some(function (variant) {
          return variant.option2 === previouslySelectedSize && variant.available;
        });
        if (isSizeAvailable) {
          // Keep the previously selected size
          sizeSelect.textContent = previouslySelectedSize;
          variantSizeLabel.textContent = previouslySelectedSize;
          variantSizeLabel.classList.remove("crossed");
        } else {
          // Reset size selection and update variant size label
          sizeSelect.textContent = "Select Size";
          variantSizeLabel.textContent = "".concat(previouslySelectedSize, " (Out of Stock)");
          variantSizeLabel.classList.add("crossed");
        }
      } else {
        // If no size was previously selected, reset to "Select Size"
        sizeSelect.textContent = "Select Size";
        variantSizeLabel.textContent = "--";
        variantSizeLabel.classList.remove("crossed");
      }

      // Update the selected variant and Add to Cart button
      updateSelectedVariant();
    }

    // Function to add the selected variant to the cart
    function isProductInCart(_x) {
      return _isProductInCart.apply(this, arguments);
    }
    function _isProductInCart() {
      _isProductInCart = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(productId) {
        var variantId,
          response,
          cart,
          _args = arguments;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              variantId = _args.length > 1 && _args[1] !== undefined ? _args[1] : null;
              _context.prev = 1;
              _context.next = 4;
              return fetch("/cart.js");
            case 4:
              response = _context.sent;
              if (response.ok) {
                _context.next = 8;
                break;
              }
              console.error("Cart fetch failed:", response.status);
              return _context.abrupt("return", false);
            case 8:
              _context.next = 10;
              return response.json();
            case 10:
              cart = _context.sent;
              if (!(!cart || !Array.isArray(cart.items))) {
                _context.next = 14;
                break;
              }
              console.error("Invalid cart structure:", cart);
              return _context.abrupt("return", false);
            case 14:
              return _context.abrupt("return", cart.items.some(function (item) {
                if (item.properties && item.properties._is_patch) return false;
                return variantId ? String(item.variant_id) === String(variantId) : String(item.product_id) === String(productId);
              }));
            case 17:
              _context.prev = 17;
              _context.t0 = _context["catch"](1);
              console.error("Error checking cart:", _context.t0);
              return _context.abrupt("return", false);
            case 21:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[1, 17]]);
      }));
      return _isProductInCart.apply(this, arguments);
    }
    function addToCart(_x2) {
      return _addToCart.apply(this, arguments);
    } // Function to trap focus within the popup for accessibility
    function _addToCart() {
      _addToCart = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(variantId) {
        var _currentProduct;
        var spinner, items, productId, selectionData, hasSelectedPatches, isInCart, response, data, cartDrawerElement;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (variantId) {
                _context2.next = 3;
                break;
              }
              console.error("Please select a valid variant.");
              return _context2.abrupt("return");
            case 3:
              spinner = document.querySelector(".add-to-cart-button .loading-spinner");
              if (spinner) {
                spinner.classList.add("visible");
              }

              // T-CART-001: Build items array with main product + selected patches
              // Note: Shopify's Cart API adds items in reverse order, so we build the array
              // with patches first, then main product last to ensure correct cart display order
              items = [];
              productId = (_currentProduct = currentProduct) === null || _currentProduct === void 0 ? void 0 : _currentProduct.id;
              selectionData = null;
              hasSelectedPatches = false;
              if (typeof window.PatchesManager !== "undefined" && variantId) {
                selectionData = window.PatchesManager.getSelectedPatches(variantId);
                hasSelectedPatches = selectionData && Array.isArray(selectionData.patches) && selectionData.patches.length > 0;
              }
              isInCart = false;
              if (!(productId && hasSelectedPatches)) {
                _context2.next = 15;
                break;
              }
              _context2.next = 14;
              return isProductInCart(productId, variantId);
            case 14:
              isInCart = _context2.sent;
            case 15:
              // Add main product only when not already in cart with patches
              if (!isInCart || !hasSelectedPatches) {
                items.push({
                  id: variantId,
                  quantity: 1
                });
              }

              // Add patches
              if (hasSelectedPatches) {
                selectionData.patches.forEach(function (patch) {
                  if (patch.variantId) {
                    items.push({
                      id: patch.variantId,
                      quantity: 1,
                      properties: {
                        _patch_for: variantId,
                        _is_patch: true
                      }
                    });
                  }
                });
              }
              if (!(items.length === 0)) {
                _context2.next = 20;
                break;
              }
              if (spinner) spinner.classList.remove("visible");
              return _context2.abrupt("return");
            case 20:
              _context2.prev = 20;
              _context2.next = 23;
              return fetch(window.Shopify.routes.root + "cart/add.js", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json"
                },
                body: JSON.stringify({
                  items: items,
                  sections: "cart-drawer,cart-icon-bubble"
                })
              });
            case 23:
              response = _context2.sent;
              _context2.next = 26;
              return response.json();
            case 26:
              data = _context2.sent;
              cartDrawerElement = document.querySelector("cart-drawer");
              if (cartDrawerElement) {
                cartDrawerElement.renderContents(data);

                // Wait for the next frame to ensure the DOM has updated
                requestAnimationFrame(function () {
                  // Add a small delay to allow for any animations or transitions
                  setTimeout(function () {
                    cartDrawerElement.open();
                  }, 100);
                });
              }

              // Clear selection and reset label after success
              if (typeof window.PatchesManager !== "undefined" && variantId) {
                window.PatchesManager.clearSelection(variantId);
                window.PatchesManager.updateTriggerButtonLabel(variantId, 0);
              }
              document.getElementById("variant-popup").style.display = "none";
              toggleScrollLock(false);
              _context2.next = 37;
              break;
            case 34:
              _context2.prev = 34;
              _context2.t0 = _context2["catch"](20);
              console.error("Error adding product to cart:", _context2.t0);
            case 37:
              _context2.prev = 37;
              if (spinner) {
                spinner.classList.remove("visible");
              }
              return _context2.finish(37);
            case 40:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[20, 34, 37, 40]]);
      }));
      return _addToCart.apply(this, arguments);
    }
    function trapFocus(popupId) {
      var popup = document.getElementById(popupId);
      var focusableElements = popup.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
      var firstElement = focusableElements[0];
      var lastElement = focusableElements[focusableElements.length - 1];
      popup.addEventListener("keydown", function (e) {
        if (e.key === "Tab") {
          if (e.shiftKey && document.activeElement === firstElement) {
            e.preventDefault();
            lastElement.focus(); // Shift+Tab moves focus to the last element
          } else if (!e.shiftKey && document.activeElement === lastElement) {
            e.preventDefault();
            firstElement.focus(); // Tab moves focus to the first element
          }
        }
      });
      firstElement.focus(); // Set focus to the first focusable element in the popup
    }

    // open/close cart drawer on button click

    if (cartButton && cartDrawer) {
      cartButton.addEventListener("click", function (event) {
        event.preventDefault(); // Prevent default link behavior if it's an <a> tag
        toggleCartDrawer();
      });
    }
    function toggleCartDrawer() {
      if (cartDrawer.classList.contains("active")) {
        cartDrawer.close();
        navButtons.classList.remove("no-bg"); // restore background from nav buttons
        // Update productNavWidget state
        updateProductNavWidget(false);
      } else {
        closePopup(); //close shop button popup if open
        navButtons.classList.add("no-bg"); // removes background from nav buttons
        // Update productNavWidget state
        updateProductNavWidget(true);
        cartDrawer.open();
        updateCartDrawerContents();
      }
    }
    function updateCartDrawerContents() {
      fetch(window.Shopify.routes.root + "cart.js").then(function (response) {
        return response.json();
      }).then(function (cart) {
        updateCartCount(cart.item_count);
      })["catch"](function (error) {
        console.error("Error updating cart:", error);
      });
    }
    function updateCartCount(count) {
      var cartIconBubble = document.getElementById("cart-icon-bubble");
      if (cartIconBubble) {
        var formattedCount;
        if (count === 0) {
          formattedCount = "00";
        } else if (count < 10) {
          formattedCount = "0" + count;
        } else {
          formattedCount = count.toString();
        }
        cartIconBubble.textContent = formattedCount;
      }
    }

    // Event listener for cart updates
    document.addEventListener("cart:updated", function () {
      var cartDrawer = document.querySelector("cart-drawer");
      if (cartDrawer && typeof cartDrawer.fetchUpdatedCart === "function") {
        cartDrawer.fetchUpdatedCart();
      } else {
        console.warn("fetchUpdatedCart method not found or cart-drawer not available yet");
        // maybe a retry mechanism or other fallback?
      }
    });

    // Event listener for various user interactions
    document.addEventListener("click", function (event) {
      var openButton = event.target.closest(".open-variant-popup");
      if (openButton) {
        var productHandle = openButton.dataset.productHandle;
        var selectedVariantId = openButton.closest("form").querySelector('input[name="id"]').value;
        openVariantPopup(productHandle, selectedVariantId); // Open the variant popup
        toggleScrollLock(true);
      } else if (event.target.matches(".close-variant-selectors")) {
        document.getElementById("variant-popup").style.display = "none";
        toggleScrollLock(false);
      } else if (event.target.matches(".add-to-cart-button")) {
        var variantId = event.target.dataset.variantId;
        addToCart(variantId);
      }

      // Toggle custom select / dropdown
      var isLabel = event.target.classList.contains("custom-select-label");
      var isItem = event.target.classList.contains("custom-select-item");
      var currentWrapper = event.target.closest(".custom-select-wrapper");
      var isMultiSelect = currentWrapper && currentWrapper.dataset.multiSelect && currentWrapper.dataset.multiSelect !== "false";

      // Close all dropdowns
      document.querySelectorAll(".custom-select-wrapper.open").forEach(function (wrapper) {
        if (wrapper !== currentWrapper) {
          wrapper.classList.remove("open");
        }
      });

      // Toggle current dropdown if label is clicked
      if (isLabel && currentWrapper && !isMultiSelect) {
        currentWrapper.classList.toggle("open");
      }

      // Close dropdown if an item is clicked
      if (isItem && currentWrapper && !isMultiSelect) {
        currentWrapper.classList.remove("open");
      }
      // end custom select toggle
    });
  })();
  // END Variant Customization Popup and Quick Cart drawer related code

  // BEGIN Patch Modal Event Delegation - T-F3-001
  (function initPatchModal() {
    var retryCount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    // Support both modal implementations: enhanced and legacy
    var modal = document.getElementById("patch-modal-enhanced") || document.getElementById("shopButtonPopup");
    if (!modal) {
      // Modal not found yet - Shopify sections may load after DOMContentLoaded
      // Retry initialization after a short delay (max 20 attempts = 2 seconds)
      if (retryCount < 20) {
        setTimeout(function () {
          return initPatchModal(retryCount + 1);
        }, 100);
      } else {
        console.warn("Patch modal initialization failed: modal element not found after 2 seconds");
      }
      return;
    }
    var focusableElements = [];
    var firstFocusableElement = null;
    var lastFocusableElement = null;

    // Open modal function
    function openModal() {
      modal.style.display = "flex";
      modal.setAttribute("aria-hidden", "false");
      document.body.classList.add("modal-open");
      document.documentElement.classList.add("modal-open");

      // Clear all stale selected classes first (Shopify might cache HTML with classes)
      var allCards = modal.querySelectorAll(".patch-product-card.selected");
      Array.prototype.forEach.call(allCards, function (card) {
        card.classList.remove("selected");
      });

      // Restore visual selection state from sessionStorage
      restoreSelectionUI();

      // Set up focus trap
      focusableElements = modal.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
      if (focusableElements.length > 0) {
        firstFocusableElement = focusableElements[0];
        lastFocusableElement = focusableElements[focusableElements.length - 1];

        // Focus on search input instead of close button
        var searchInput = modal.querySelector('#patch-live-search');
        if (searchInput) {
          searchInput.focus();
        }
      }
    }

    // Restore visual selection state from sessionStorage
    function restoreSelectionUI() {
      var variantId = modal.getAttribute("data-current-variant-id");
      if (!variantId) return;

      // Get selected patches (state === 'selected') from sessionStorage
      if (typeof window.PatchesManager === "undefined") return;
      var selectedPatches = window.PatchesManager.getSelectedOnlyPatches(variantId);
      if (!selectedPatches || selectedPatches.length === 0) {
        if (typeof window.updateBottomBar === "function") {
          window.updateBottomBar(variantId);
        }
        return;
      }

      // Create a Set of selected patch IDs for fast lookup
      var selectedIds = new Set(selectedPatches.map(function (patch) {
        return String(patch.id);
      }));

      // Add .selected class to matching cards
      var cards = modal.querySelectorAll(".patch-product-card");
      Array.prototype.forEach.call(cards, function (card) {
        var cardId = card.getAttribute("data-product-id");
        if (cardId && selectedIds.has(cardId)) {
          card.classList.add("selected");
        } else {
          card.classList.remove("selected");
        }
      });

      // Update bottom bar to show count
      if (typeof window.updateBottomBar === "function") {
        window.updateBottomBar(variantId);
      }
    }

    // T-UI-004: Update bottom bar visibility and count
    window.updateBottomBar = function (variantId) {
      if (!variantId) return;
      var bottomBar = modal.querySelector("[data-selection-bar]");
      var countElement = modal.querySelector("[data-selection-count]");
      var priceContainer = modal.querySelector("[data-selection-price]");
      var priceWhole = modal.querySelector("[data-price-dollars]");
      var priceCents = modal.querySelector("[data-price-cents]");
      if (!bottomBar || !countElement) return;

      // Get current selection count
      var count = typeof window.PatchesManager !== "undefined" ? window.PatchesManager.getSelectionCount(variantId) : 0;
      if (count > 0) {
        // Show bottom bar with count
        bottomBar.removeAttribute("hidden");
        countElement.textContent = count === 1 ? "1 patch selected" : count + " patches selected";

        // Calculate total price from selected patches
        if (priceContainer && priceWhole && priceCents && typeof window.PatchesManager !== "undefined") {
          var selectedPatches = window.PatchesManager.getSelectedOnlyPatches(variantId);
          var totalCents = selectedPatches.reduce(function (sum, patch) {
            return sum + (Number(patch.price) || 0);
          }, 0);

          // Convert cents to dollars and cents
          var dollars = Math.floor(totalCents / 100);
          var cents = totalCents % 100;

          // Format and display
          priceWhole.textContent = "$".concat(dollars);
          priceCents.textContent = ".".concat(cents.toString().padStart(2, "0"));
          priceContainer.removeAttribute("hidden");
        }
      } else {
        // Hide bottom bar and price
        bottomBar.setAttribute("hidden", "");
        if (priceContainer) {
          priceContainer.setAttribute("hidden", "");
        }
      }
    };

    // Close modal function
    function closeModal() {
      modal.style.display = "none";
      modal.setAttribute("aria-hidden", "true");
      document.body.classList.remove("modal-open");
      document.documentElement.classList.remove("modal-open");

      // Return focus to trigger button if possible
      var triggerButton = document.querySelector("[data-patch-trigger]:focus, [data-patch-trigger].recently-clicked");
      if (triggerButton) {
        triggerButton.focus();
        triggerButton.classList.remove("recently-clicked");
      }
    }

    // Global event delegation for patch triggers
    document.addEventListener("click", function (event) {
      // Handle patch trigger buttons
      var triggerMatch = event.target.closest("[data-patch-trigger]");
      if (triggerMatch) {
        if (triggerMatch.disabled) {
          event.preventDefault();
          return;
        }
        event.preventDefault();
        var triggerButton = triggerMatch;
        triggerButton.classList.add("recently-clicked");

        // T-UI-002: Store product ID on modal for patch selection context
        var productId = triggerButton.getAttribute("data-product-id");
        if (productId) {
          modal.setAttribute("data-current-product-id", productId);
        }
        var variantId = triggerButton.getAttribute("data-variant-id");
        if (variantId) {
          modal.setAttribute("data-current-variant-id", variantId);
        }
        openModal();
        return;
      }

      // Handle modal close buttons and backdrop
      if (event.target.closest("[data-modal-close]") || event.target === modal) {
        event.preventDefault();
        closeModal();
        return;
      }

      // T-UI-003: Handle patch card clicks to toggle selection
      var patchCard = event.target.closest(".patch-product-card");
      // Check if modal is open: enhanced modal uses aria-hidden, legacy uses visibility/display
      var isModalOpen = modal.getAttribute("aria-hidden") === "false" || modal.getAttribute("aria-hidden") === null && modal.offsetParent !== null;
      if (patchCard && isModalOpen) {
        var _patchCard$querySelec;
        event.preventDefault();
        var _variantId = modal.getAttribute("data-current-variant-id");
        if (!_variantId) {
          console.warn("No variant ID found on modal");
          return;
        }
        var patchId = patchCard.getAttribute("data-product-id");
        var patchVariantId = patchCard.getAttribute("data-variant-id");
        var patchTitle = ((_patchCard$querySelec = patchCard.querySelector(".patch-product-title")) === null || _patchCard$querySelec === void 0 ? void 0 : _patchCard$querySelec.textContent) || "";
        var patchPrice = patchCard.getAttribute("data-price") || "0";
        if (!patchId || !patchVariantId) {
          console.warn("Patch card missing required data attributes");
          return;
        }

        // Toggle selection state
        var isSelected = patchCard.classList.contains("selected");
        if (isSelected) {
          // Remove from selection
          patchCard.classList.remove("selected");
          if (typeof window.PatchesManager !== "undefined") {
            window.PatchesManager.removePatchFromSelection(_variantId, patchId);
          }
        } else {
          // Add to selection
          patchCard.classList.add("selected");
          if (typeof window.PatchesManager !== "undefined") {
            var patchData = {
              id: patchId,
              variantId: patchVariantId,
              title: patchTitle,
              price: patchPrice
            };
            window.PatchesManager.addPatchToSelection(_variantId, patchData);
          }
        }

        // Update bottom bar
        if (typeof window.updateBottomBar === "function") {
          window.updateBottomBar(_variantId);
        }

        // Force visual state update using global restore function to prevent race conditions
        requestAnimationFrame(function () {
          if (typeof window.restoreSelectionState === "function") {
            window.restoreSelectionState();
          }
        });
        return;
      }

      // T-UI-004: Handle APPLY button click
      if (event.target.closest("[data-selection-apply]")) {
        event.preventDefault();
        var _variantId2 = modal.getAttribute("data-current-variant-id");
        if (!_variantId2) return;

        // Update trigger button label
        if (typeof window.PatchesManager !== "undefined") {
          var count = window.PatchesManager.getSelectionCount(_variantId2);
          window.PatchesManager.updateTriggerButtonLabel(_variantId2, count);
        }

        // Close modal
        closeModal();
        return;
      }

      // T-UI-004: Handle bottom bar CLOSE button
      if (event.target.closest("[data-selection-close]")) {
        event.preventDefault();
        var _variantId3 = modal.getAttribute("data-current-variant-id");
        if (!_variantId3) return;

        // Clear all selections
        if (typeof window.PatchesManager !== "undefined") {
          window.PatchesManager.clearSelection(_variantId3);
        }

        // Remove all .selected classes
        var cards = modal.querySelectorAll(".patch-product-card.selected");
        Array.prototype.forEach.call(cards, function (card) {
          card.classList.remove("selected");
        });

        // Update bottom bar and trigger button
        if (typeof window.updateBottomBar === "function") {
          window.updateBottomBar(_variantId3);
        }
        if (typeof window.PatchesManager !== "undefined") {
          window.PatchesManager.updateTriggerButtonLabel(_variantId3, 0);
        }
        return;
      }
    });

    // ESC key to close modal
    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && modal.getAttribute("aria-hidden") === "false") {
        closeModal();
        return;
      }

      // Focus trap when modal is open
      if (modal.getAttribute("aria-hidden") === "false" && event.key === "Tab") {
        if (event.shiftKey) {
          if (document.activeElement === firstFocusableElement) {
            event.preventDefault();
            lastFocusableElement.focus();
          }
        } else {
          if (document.activeElement === lastFocusableElement) {
            event.preventDefault();
            firstFocusableElement.focus();
          }
        }
      }
    });
  })();
  // END Patch Modal Event Delegation

  // T-PATCH-CTA: Auto-open patches modal if URL parameter is present
  (function () {
    var urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get("open_patches") === "true") {
      // Wait for DOM to be fully ready
      var autoOpenModal = function autoOpenModal() {
        var patchTrigger = document.querySelector("[data-patch-trigger]");
        if (patchTrigger) {
          // Simulate click on patch trigger button
          patchTrigger.click();
        }
      };
      if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", autoOpenModal);
      } else {
        // DOM already loaded
        autoOpenModal();
      }
    }
  })();

  // T-SEARCH-001: Initialize Live Search functionality
  // Import and initialize live search for patch modal
  var LiveSearchModule = __webpack_require__(/*! ./live-search.js */ "./src/js/live-search.js");
  if (typeof LiveSearchModule === "function") {
    new LiveSearchModule();
  } else if (LiveSearchModule && typeof LiveSearchModule["default"] === "function") {
    new LiveSearchModule["default"]();
  }

  // T-CART-003: Selection persistence across modal filter/search
  // Public API: Restore selection state for current product in modal
  window.restoreSelectionState = function () {
    // Support both modal implementations
    var modal = document.getElementById("patch-modal-enhanced") || document.getElementById("shopButtonPopup");
    if (!modal) return;
    var variantId = modal.getAttribute("data-current-variant-id");
    if (!variantId) return;

    // Get selected patches from sessionStorage
    if (typeof window.PatchesManager === "undefined") return;
    var selectionData = window.PatchesManager.getSelectedPatches(variantId);
    if (!selectionData || !selectionData.patches || selectionData.patches.length === 0) {
      // No selection to restore, but still need to clear any stale .selected classes
      var _cards = modal.querySelectorAll(".patch-product-card");
      Array.prototype.forEach.call(_cards, function (card) {
        card.classList.remove("selected");
      });
      return;
    }

    // Create a Set of selected patch IDs for fast lookup
    var selectedIds = new Set(selectionData.patches.map(function (patch) {
      return String(patch.id);
    }));

    // Add .selected class to matching cards
    var cards = modal.querySelectorAll(".patch-product-card");
    Array.prototype.forEach.call(cards, function (card) {
      var cardId = card.getAttribute("data-product-id");
      if (cardId && selectedIds.has(cardId)) {
        card.classList.add("selected");
      } else {
        card.classList.remove("selected");
      }
    });

    // Update bottom bar to show count
    if (typeof window.updateBottomBar === "function") {
      window.updateBottomBar(variantId);
    }
  };

  // Hook selection restoration into LiveSearch filter/search completion
  function hookSelectionRestoration() {
    if (!window.LiveSearch) {
      console.warn("LiveSearch not available for selection restoration hook");
      return;
    }

    // Store original methods
    var originalSearch = window.LiveSearch.search.bind(window.LiveSearch);
    var originalClearResults = window.LiveSearch.clearResults.bind(window.LiveSearch);

    // Wrap search method to restore selection after filtering
    window.LiveSearch.search = function (searchTerm) {
      originalSearch(searchTerm);

      // Restore selection after requestAnimationFrame completes
      // Double RAF ensures DOM updates are complete
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          if (typeof window.restoreSelectionState === "function") {
            window.restoreSelectionState();
          }
        });
      });
    };

    // Wrap clearResults method to restore selection after showing all cards
    window.LiveSearch.clearResults = function () {
      originalClearResults();

      // Restore selection after requestAnimationFrame completes
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          if (typeof window.restoreSelectionState === "function") {
            window.restoreSelectionState();
          }
        });
      });
    };
  }

  // Initialize hooks after LiveSearch is ready (wait for DOMContentLoaded)
  setTimeout(hookSelectionRestoration, 100);
});

/***/ }),

/***/ "./src/js/live-search.js":
/*!*******************************!*\
  !*** ./src/js/live-search.js ***!
  \*******************************/
/***/ ((module) => {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Live Search Functionality - T-SEARCH-001
 * Implements live search with 3-character minimum and debounced search
 *
 * Requirements:
 * - Search input field with data-live-search="true"
 * - 3-character minimum trigger
 * - 300ms debounced search
 * - Live filtering of products
 *
 * @class LiveSearch
 */
var LiveSearch = /*#__PURE__*/function () {
  /**
   * Creates an instance of LiveSearch
   * @param {Object} options - Configuration options
   * @param {number} options.minSearchLength - Minimum search term length (default: 3)
   * @param {number} options.debounceDelay - Debounce delay in milliseconds (default: 300)
   */
  function LiveSearch() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, LiveSearch);
    // Configuration
    this.config = {
      minSearchLength: options.minSearchLength || 3,
      debounceDelay: options.debounceDelay || 300,
      searchInputSelector: 'input[data-live-search="true"]',
      resultsContainerSelector: '[data-live-search-results="true"]',
      productCardSelector: ".patch-product-card",
      noResultsSelector: '[data-no-results="true"]'
    };

    // State
    this.state = {
      searchInput: null,
      resultsContainer: null,
      productCards: [],
      searchCallCount: 0,
      lastSearchTerm: "",
      debounceTimeout: null,
      isInitialized: false
    };
    this.init();
  }

  /**
   * Initialize the live search functionality
   * @returns {boolean} True if initialization successful, false otherwise
   */
  return _createClass(LiveSearch, [{
    key: "init",
    value: function init() {
      try {
        this.state.searchInput = document.querySelector(this.config.searchInputSelector);
        this.state.resultsContainer = document.querySelector(this.config.resultsContainerSelector);
        if (!this.state.searchInput || !this.state.resultsContainer) {
          console.warn("Live search: Required elements not found", {
            searchInput: !!this.state.searchInput,
            resultsContainer: !!this.state.resultsContainer
          });
          return false;
        }
        this.state.productCards = Array.from(this.state.resultsContainer.querySelectorAll(this.config.productCardSelector));
        if (this.state.productCards.length === 0) {
          console.warn("Live search: No product cards found");
        }
        this.attachEventListeners();
        this.initMobileSearch(); // Initialize mobile search functionality
        this.state.isInitialized = true;
        console.log("Live search initialized", {
          productCards: this.state.productCards.length,
          minSearchLength: this.config.minSearchLength,
          debounceDelay: this.config.debounceDelay
        });
        return true;
      } catch (error) {
        console.error("Live search initialization failed:", error);
        return false;
      }
    }

    /**
     * Attach event listeners to search input
     * @private
     */
  }, {
    key: "attachEventListeners",
    value: function attachEventListeners() {
      var _this = this;
      if (!this.state.searchInput) return;

      // Input event with error handling
      this.state.searchInput.addEventListener("input", function (event) {
        try {
          _this.handleInput(event);
          _this.toggleClearButton();
        } catch (error) {
          console.error("Live search: Input handler error:", error);
        }
      });

      // Escape key to clear search
      this.state.searchInput.addEventListener("keydown", function (event) {
        try {
          if (event.key === "Escape") {
            _this.clearSearch();
          }
        } catch (error) {
          console.error("Live search: Keydown handler error:", error);
        }
      });

      // Focus event for accessibility
      this.state.searchInput.addEventListener("focus", function () {
        _this.state.searchInput.setAttribute("aria-expanded", "true");
      });

      // Blur event for accessibility
      this.state.searchInput.addEventListener("blur", function () {
        _this.state.searchInput.setAttribute("aria-expanded", "false");
      });

      // Desktop clear button
      var clearButton = document.querySelector('[data-search-clear]');
      if (clearButton) {
        clearButton.addEventListener('click', function () {
          _this.clearSearch();
          _this.toggleClearButton();
        });
      }
    }

    /**
     * Handle input events with debouncing
     * @param {Event} event - Input event
     * @private
     */
  }, {
    key: "handleInput",
    value: function handleInput(event) {
      var _this2 = this;
      if (!this.state.isInitialized) return;
      var searchTerm = event.target.value.trim();

      // Clear existing timeout
      if (this.state.debounceTimeout) {
        clearTimeout(this.state.debounceTimeout);
        this.state.debounceTimeout = null;
      }

      // Update accessibility attributes
      this.state.searchInput.setAttribute("aria-busy", "true");

      // If less than minimum characters, clear search
      if (searchTerm.length < this.config.minSearchLength) {
        this.state.debounceTimeout = setTimeout(function () {
          _this2.clearResults();
          _this2.state.searchInput.setAttribute("aria-busy", "false");
        }, this.config.debounceDelay);
        return;
      }

      // Debounced search
      this.state.debounceTimeout = setTimeout(function () {
        _this2.search(searchTerm);
        _this2.state.searchInput.setAttribute("aria-busy", "false");
      }, this.config.debounceDelay);
    }

    /**
     * Perform search on product cards
     * @param {string} searchTerm - Search term to filter by
     * @public
     */
  }, {
    key: "search",
    value: function search(searchTerm) {
      var _this3 = this;
      if (!this.state.isInitialized) return;
      this.state.searchCallCount++;
      this.state.lastSearchTerm = searchTerm;
      if (!searchTerm || searchTerm.length < this.config.minSearchLength) {
        this.clearResults();
        return;
      }
      var normalizedSearchTerm = searchTerm.toLowerCase();
      var visibleCount = 0;

      // Use requestAnimationFrame for better performance
      requestAnimationFrame(function () {
        _this3.state.productCards.forEach(function (card) {
          var shouldShow = _this3.cardMatchesSearch(card, normalizedSearchTerm);
          if (shouldShow) {
            card.style.display = "";
            card.setAttribute("aria-hidden", "false");
            visibleCount++;
          } else {
            card.style.display = "none";
            card.setAttribute("aria-hidden", "true");
          }
        });
        _this3.updateNoResultsMessage(visibleCount === 0, searchTerm);

        // Update search results count for accessibility
        var resultsCount = "".concat(visibleCount, " products found");
        _this3.state.searchInput.setAttribute("aria-description", resultsCount);
        console.log("Live search: \"".concat(searchTerm, "\" - ").concat(visibleCount, " results"));
      });
    }
  }, {
    key: "cardMatchesSearch",
    value: function cardMatchesSearch(card, searchTerm) {
      // Get searchable text from the product card
      var title = this.getElementText(card, ".patch-product-title");
      var description = this.getElementText(card, ".patch-product-description");
      var tags = card.dataset.productTags || "";
      var type = card.dataset.productType || "";
      var vendor = card.dataset.productVendor || "";

      // Combine all searchable text
      var searchableText = [title, description, tags, type, vendor].join(" ").toLowerCase();

      // Check if search term is found in any of the searchable text
      return searchableText.includes(searchTerm);
    }
  }, {
    key: "getElementText",
    value: function getElementText(container, selector) {
      var element = container.querySelector(selector);
      return element ? element.textContent.trim() : "";
    }

    /**
     * Clear search input and results
     * @public
     */
  }, {
    key: "clearSearch",
    value: function clearSearch() {
      if (this.state.searchInput) {
        this.state.searchInput.value = "";
        this.clearResults();
        this.state.searchInput.focus();
      }
    }

    /**
     * Toggle clear button visibility based on input value
     * @private
     */
  }, {
    key: "toggleClearButton",
    value: function toggleClearButton() {
      var clearButton = document.querySelector('[data-search-clear]');
      if (!clearButton || !this.state.searchInput) return;
      if (this.state.searchInput.value.trim().length > 0) {
        clearButton.removeAttribute('hidden');
      } else {
        clearButton.setAttribute('hidden', 'true');
      }
    }

    /**
     * Clear search results and show all products
     * @public
     */
  }, {
    key: "clearResults",
    value: function clearResults() {
      this.state.lastSearchTerm = "";

      // Show all product cards
      this.state.productCards.forEach(function (card) {
        card.style.display = "";
        card.removeAttribute("aria-hidden");
      });
      this.updateNoResultsMessage(false);

      // Update accessibility attributes
      if (this.state.searchInput) {
        this.state.searchInput.removeAttribute("aria-description");
      }
    }

    /**
     * Update no results message display
     * @param {boolean} showMessage - Whether to show the message
     * @param {string} searchTerm - Current search term
     * @private
     */
  }, {
    key: "updateNoResultsMessage",
    value: function updateNoResultsMessage(showMessage) {
      var searchTerm = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
      if (!this.state.resultsContainer) return;
      var noResultsElement = this.state.resultsContainer.querySelector(this.config.noResultsSelector);
      if (showMessage) {
        if (!noResultsElement) {
          noResultsElement = document.createElement("div");
          noResultsElement.setAttribute("data-no-results", "true");
          noResultsElement.className = "live-search-no-results";
          noResultsElement.setAttribute("role", "status");
          noResultsElement.setAttribute("aria-live", "polite");
          noResultsElement.innerHTML = "\n        <div class=\"no-results-info-container\" aria-hidden=\"true\">  \n        <p>No products found for \"".concat(searchTerm, "\"</p>\n          <p>Try adjusting your search or <button type=\"button\" class=\"link\" onclick=\"window.LiveSearch.clearSearch()\">clear search</button></p>\n          </div>\n        ");
          this.state.resultsContainer.appendChild(noResultsElement);
        } else {
          var firstParagraph = noResultsElement.querySelector("p");
          if (firstParagraph) {
            firstParagraph.textContent = "No products found for \"".concat(searchTerm, "\"");
          }
        }
        noResultsElement.style.display = "block";
      } else {
        if (noResultsElement) {
          noResultsElement.style.display = "none";
        }
      }
    }

    /**
     * Initialize mobile search overlay and sync
     * @private
     */
  }, {
    key: "initMobileSearch",
    value: function initMobileSearch() {
      var _this4 = this;
      var trigger = document.querySelector('[data-mobile-search-trigger]');
      var overlay = document.querySelector('[data-mobile-search-overlay]');
      var mobileInput = document.querySelector('[data-mobile-search-input]');
      var closeBtn = document.querySelector('[data-mobile-search-close]');
      var patchGrid = document.getElementById('patch-grid');
      if (!trigger || !overlay || !mobileInput || !closeBtn) {
        console.warn('Live search: Mobile search elements not found');
        return;
      }

      // Open mobile search
      trigger.addEventListener('click', function () {
        overlay.removeAttribute('hidden');
        mobileInput.focus();

        // Sync current desktop search value to mobile
        if (_this4.state.searchInput) {
          mobileInput.value = _this4.state.searchInput.value;
        }

        // Smooth scroll to patch grid
        if (patchGrid) {
          setTimeout(function () {
            patchGrid.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          }, 100);
        }
      });

      // Close mobile search
      var closeMobileSearch = function closeMobileSearch() {
        overlay.setAttribute('hidden', 'true');
        mobileInput.value = '';

        // Clear desktop search too
        if (_this4.state.searchInput) {
          _this4.state.searchInput.value = '';
        }
        _this4.clearResults();
      };
      closeBtn.addEventListener('click', closeMobileSearch);

      // Sync mobile input to desktop input (triggers LiveSearch)
      mobileInput.addEventListener('input', function (e) {
        if (_this4.state.searchInput) {
          _this4.state.searchInput.value = e.target.value;
          // Trigger input event on desktop input to activate LiveSearch
          _this4.state.searchInput.dispatchEvent(new Event('input', {
            bubbles: true
          }));
        }
      });

      // Escape key closes mobile search
      mobileInput.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          closeMobileSearch();
        }
      });
    }

    /**
     * Get search statistics for testing and debugging
     * @returns {Object} Search statistics
     * @public
     */
  }, {
    key: "getSearchStats",
    value: function getSearchStats() {
      return {
        lastSearchTerm: this.state.lastSearchTerm,
        searchCallCount: this.state.searchCallCount,
        totalProducts: this.state.productCards.length,
        visibleProducts: this.state.productCards.filter(function (card) {
          return card.style.display !== "none";
        }).length,
        isInitialized: this.state.isInitialized,
        config: _objectSpread({}, this.config)
      };
    }

    // Backwards compatibility getters for tests
  }, {
    key: "lastSearchTerm",
    get: function get() {
      return this.state.lastSearchTerm;
    }
  }, {
    key: "searchCallCount",
    get: function get() {
      return this.state.searchCallCount;
    }
  }, {
    key: "minSearchLength",
    get: function get() {
      return this.config.minSearchLength;
    }
  }, {
    key: "debounceDelay",
    get: function get() {
      return this.config.debounceDelay;
    }
  }]);
}(); // Initialize live search when DOM is ready
document.addEventListener("DOMContentLoaded", function () {
  window.LiveSearch = new LiveSearch();
});

// Export for testing
if ( true && module.exports) {
  module.exports = LiveSearch;
}

/***/ }),

/***/ "./src/scss/explainer-section.scss":
/*!*****************************************!*\
  !*** ./src/scss/explainer-section.scss ***!
  \*****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/scss/hero-index-video.scss":
/*!****************************************!*\
  !*** ./src/scss/hero-index-video.scss ***!
  \****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/scss/index-faq.scss":
/*!*********************************!*\
  !*** ./src/scss/index-faq.scss ***!
  \*********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/scss/index-text-scroll.scss":
/*!*****************************************!*\
  !*** ./src/scss/index-text-scroll.scss ***!
  \*****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/scss/live-search.scss":
/*!***********************************!*\
  !*** ./src/scss/live-search.scss ***!
  \***********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/scss/new-cart-items.scss":
/*!**************************************!*\
  !*** ./src/scss/new-cart-items.scss ***!
  \**************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/scss/newsletter-alternative.scss":
/*!**********************************************!*\
  !*** ./src/scss/newsletter-alternative.scss ***!
  \**********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/scss/newsletter-footer.scss":
/*!*****************************************!*\
  !*** ./src/scss/newsletter-footer.scss ***!
  \*****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/scss/partnership.scss":
/*!***********************************!*\
  !*** ./src/scss/partnership.scss ***!
  \***********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/scss/patch-subscribe-block.scss":
/*!*********************************************!*\
  !*** ./src/scss/patch-subscribe-block.scss ***!
  \*********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/scss/patches-modal.scss":
/*!*************************************!*\
  !*** ./src/scss/patches-modal.scss ***!
  \*************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/scss/patches-overlay.scss":
/*!***************************************!*\
  !*** ./src/scss/patches-overlay.scss ***!
  \***************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/scss/patches-page.scss":
/*!************************************!*\
  !*** ./src/scss/patches-page.scss ***!
  \************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/scss/product-reviews.scss":
/*!***************************************!*\
  !*** ./src/scss/product-reviews.scss ***!
  \***************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/scss/product.scss":
/*!*******************************!*\
  !*** ./src/scss/product.scss ***!
  \*******************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/scss/products-showcase.scss":
/*!*****************************************!*\
  !*** ./src/scss/products-showcase.scss ***!
  \*****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/scss/section-faq.scss":
/*!***********************************!*\
  !*** ./src/scss/section-faq.scss ***!
  \***********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/scss/section-landing-page.scss":
/*!********************************************!*\
  !*** ./src/scss/section-landing-page.scss ***!
  \********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/scss/section-main-page-custom.scss":
/*!************************************************!*\
  !*** ./src/scss/section-main-page-custom.scss ***!
  \************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/scss/announcement-bar.scss":
/*!****************************************!*\
  !*** ./src/scss/announcement-bar.scss ***!
  \****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/scss/app.scss":
/*!***************************!*\
  !*** ./src/scss/app.scss ***!
  \***************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/scss/cart-patch-integration.scss":
/*!**********************************************!*\
  !*** ./src/scss/cart-patch-integration.scss ***!
  \**********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/scss/custom-collection-section.scss":
/*!*************************************************!*\
  !*** ./src/scss/custom-collection-section.scss ***!
  \*************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/scss/customer.scss":
/*!********************************!*\
  !*** ./src/scss/customer.scss ***!
  \********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"/assets/app": 0,
/******/ 			"assets/customer": 0,
/******/ 			"assets/custom-collection-section": 0,
/******/ 			"assets/cart-patch-integration": 0,
/******/ 			"assets/app": 0,
/******/ 			"assets/announcement-bar": 0,
/******/ 			"assets/section-main-page-custom": 0,
/******/ 			"assets/section-landing-page": 0,
/******/ 			"assets/section-faq": 0,
/******/ 			"assets/products-showcase": 0,
/******/ 			"assets/product": 0,
/******/ 			"assets/product-reviews": 0,
/******/ 			"assets/patches-page": 0,
/******/ 			"assets/patches-overlay": 0,
/******/ 			"assets/patches-modal": 0,
/******/ 			"assets/patch-subscribe-block": 0,
/******/ 			"assets/partnership": 0,
/******/ 			"assets/newsletter-footer": 0,
/******/ 			"assets/newsletter-alternative": 0,
/******/ 			"assets/new-cart-items": 0,
/******/ 			"assets/live-search": 0,
/******/ 			"assets/index-text-scroll": 0,
/******/ 			"assets/index-faq": 0,
/******/ 			"assets/hero-index-video": 0,
/******/ 			"assets/explainer-section": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunknivis_tailwind"] = self["webpackChunknivis_tailwind"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	__webpack_require__.O(undefined, ["assets/customer","assets/custom-collection-section","assets/cart-patch-integration","assets/app","assets/announcement-bar","assets/section-main-page-custom","assets/section-landing-page","assets/section-faq","assets/products-showcase","assets/product","assets/product-reviews","assets/patches-page","assets/patches-overlay","assets/patches-modal","assets/patch-subscribe-block","assets/partnership","assets/newsletter-footer","assets/newsletter-alternative","assets/new-cart-items","assets/live-search","assets/index-text-scroll","assets/index-faq","assets/hero-index-video","assets/explainer-section"], () => (__webpack_require__("./src/js/app.js")))
/******/ 	__webpack_require__.O(undefined, ["assets/customer","assets/custom-collection-section","assets/cart-patch-integration","assets/app","assets/announcement-bar","assets/section-main-page-custom","assets/section-landing-page","assets/section-faq","assets/products-showcase","assets/product","assets/product-reviews","assets/patches-page","assets/patches-overlay","assets/patches-modal","assets/patch-subscribe-block","assets/partnership","assets/newsletter-footer","assets/newsletter-alternative","assets/new-cart-items","assets/live-search","assets/index-text-scroll","assets/index-faq","assets/hero-index-video","assets/explainer-section"], () => (__webpack_require__("./src/scss/announcement-bar.scss")))
/******/ 	__webpack_require__.O(undefined, ["assets/customer","assets/custom-collection-section","assets/cart-patch-integration","assets/app","assets/announcement-bar","assets/section-main-page-custom","assets/section-landing-page","assets/section-faq","assets/products-showcase","assets/product","assets/product-reviews","assets/patches-page","assets/patches-overlay","assets/patches-modal","assets/patch-subscribe-block","assets/partnership","assets/newsletter-footer","assets/newsletter-alternative","assets/new-cart-items","assets/live-search","assets/index-text-scroll","assets/index-faq","assets/hero-index-video","assets/explainer-section"], () => (__webpack_require__("./src/scss/app.scss")))
/******/ 	__webpack_require__.O(undefined, ["assets/customer","assets/custom-collection-section","assets/cart-patch-integration","assets/app","assets/announcement-bar","assets/section-main-page-custom","assets/section-landing-page","assets/section-faq","assets/products-showcase","assets/product","assets/product-reviews","assets/patches-page","assets/patches-overlay","assets/patches-modal","assets/patch-subscribe-block","assets/partnership","assets/newsletter-footer","assets/newsletter-alternative","assets/new-cart-items","assets/live-search","assets/index-text-scroll","assets/index-faq","assets/hero-index-video","assets/explainer-section"], () => (__webpack_require__("./src/scss/cart-patch-integration.scss")))
/******/ 	__webpack_require__.O(undefined, ["assets/customer","assets/custom-collection-section","assets/cart-patch-integration","assets/app","assets/announcement-bar","assets/section-main-page-custom","assets/section-landing-page","assets/section-faq","assets/products-showcase","assets/product","assets/product-reviews","assets/patches-page","assets/patches-overlay","assets/patches-modal","assets/patch-subscribe-block","assets/partnership","assets/newsletter-footer","assets/newsletter-alternative","assets/new-cart-items","assets/live-search","assets/index-text-scroll","assets/index-faq","assets/hero-index-video","assets/explainer-section"], () => (__webpack_require__("./src/scss/custom-collection-section.scss")))
/******/ 	__webpack_require__.O(undefined, ["assets/customer","assets/custom-collection-section","assets/cart-patch-integration","assets/app","assets/announcement-bar","assets/section-main-page-custom","assets/section-landing-page","assets/section-faq","assets/products-showcase","assets/product","assets/product-reviews","assets/patches-page","assets/patches-overlay","assets/patches-modal","assets/patch-subscribe-block","assets/partnership","assets/newsletter-footer","assets/newsletter-alternative","assets/new-cart-items","assets/live-search","assets/index-text-scroll","assets/index-faq","assets/hero-index-video","assets/explainer-section"], () => (__webpack_require__("./src/scss/customer.scss")))
/******/ 	__webpack_require__.O(undefined, ["assets/customer","assets/custom-collection-section","assets/cart-patch-integration","assets/app","assets/announcement-bar","assets/section-main-page-custom","assets/section-landing-page","assets/section-faq","assets/products-showcase","assets/product","assets/product-reviews","assets/patches-page","assets/patches-overlay","assets/patches-modal","assets/patch-subscribe-block","assets/partnership","assets/newsletter-footer","assets/newsletter-alternative","assets/new-cart-items","assets/live-search","assets/index-text-scroll","assets/index-faq","assets/hero-index-video","assets/explainer-section"], () => (__webpack_require__("./src/scss/explainer-section.scss")))
/******/ 	__webpack_require__.O(undefined, ["assets/customer","assets/custom-collection-section","assets/cart-patch-integration","assets/app","assets/announcement-bar","assets/section-main-page-custom","assets/section-landing-page","assets/section-faq","assets/products-showcase","assets/product","assets/product-reviews","assets/patches-page","assets/patches-overlay","assets/patches-modal","assets/patch-subscribe-block","assets/partnership","assets/newsletter-footer","assets/newsletter-alternative","assets/new-cart-items","assets/live-search","assets/index-text-scroll","assets/index-faq","assets/hero-index-video","assets/explainer-section"], () => (__webpack_require__("./src/scss/hero-index-video.scss")))
/******/ 	__webpack_require__.O(undefined, ["assets/customer","assets/custom-collection-section","assets/cart-patch-integration","assets/app","assets/announcement-bar","assets/section-main-page-custom","assets/section-landing-page","assets/section-faq","assets/products-showcase","assets/product","assets/product-reviews","assets/patches-page","assets/patches-overlay","assets/patches-modal","assets/patch-subscribe-block","assets/partnership","assets/newsletter-footer","assets/newsletter-alternative","assets/new-cart-items","assets/live-search","assets/index-text-scroll","assets/index-faq","assets/hero-index-video","assets/explainer-section"], () => (__webpack_require__("./src/scss/index-faq.scss")))
/******/ 	__webpack_require__.O(undefined, ["assets/customer","assets/custom-collection-section","assets/cart-patch-integration","assets/app","assets/announcement-bar","assets/section-main-page-custom","assets/section-landing-page","assets/section-faq","assets/products-showcase","assets/product","assets/product-reviews","assets/patches-page","assets/patches-overlay","assets/patches-modal","assets/patch-subscribe-block","assets/partnership","assets/newsletter-footer","assets/newsletter-alternative","assets/new-cart-items","assets/live-search","assets/index-text-scroll","assets/index-faq","assets/hero-index-video","assets/explainer-section"], () => (__webpack_require__("./src/scss/index-text-scroll.scss")))
/******/ 	__webpack_require__.O(undefined, ["assets/customer","assets/custom-collection-section","assets/cart-patch-integration","assets/app","assets/announcement-bar","assets/section-main-page-custom","assets/section-landing-page","assets/section-faq","assets/products-showcase","assets/product","assets/product-reviews","assets/patches-page","assets/patches-overlay","assets/patches-modal","assets/patch-subscribe-block","assets/partnership","assets/newsletter-footer","assets/newsletter-alternative","assets/new-cart-items","assets/live-search","assets/index-text-scroll","assets/index-faq","assets/hero-index-video","assets/explainer-section"], () => (__webpack_require__("./src/scss/live-search.scss")))
/******/ 	__webpack_require__.O(undefined, ["assets/customer","assets/custom-collection-section","assets/cart-patch-integration","assets/app","assets/announcement-bar","assets/section-main-page-custom","assets/section-landing-page","assets/section-faq","assets/products-showcase","assets/product","assets/product-reviews","assets/patches-page","assets/patches-overlay","assets/patches-modal","assets/patch-subscribe-block","assets/partnership","assets/newsletter-footer","assets/newsletter-alternative","assets/new-cart-items","assets/live-search","assets/index-text-scroll","assets/index-faq","assets/hero-index-video","assets/explainer-section"], () => (__webpack_require__("./src/scss/new-cart-items.scss")))
/******/ 	__webpack_require__.O(undefined, ["assets/customer","assets/custom-collection-section","assets/cart-patch-integration","assets/app","assets/announcement-bar","assets/section-main-page-custom","assets/section-landing-page","assets/section-faq","assets/products-showcase","assets/product","assets/product-reviews","assets/patches-page","assets/patches-overlay","assets/patches-modal","assets/patch-subscribe-block","assets/partnership","assets/newsletter-footer","assets/newsletter-alternative","assets/new-cart-items","assets/live-search","assets/index-text-scroll","assets/index-faq","assets/hero-index-video","assets/explainer-section"], () => (__webpack_require__("./src/scss/newsletter-alternative.scss")))
/******/ 	__webpack_require__.O(undefined, ["assets/customer","assets/custom-collection-section","assets/cart-patch-integration","assets/app","assets/announcement-bar","assets/section-main-page-custom","assets/section-landing-page","assets/section-faq","assets/products-showcase","assets/product","assets/product-reviews","assets/patches-page","assets/patches-overlay","assets/patches-modal","assets/patch-subscribe-block","assets/partnership","assets/newsletter-footer","assets/newsletter-alternative","assets/new-cart-items","assets/live-search","assets/index-text-scroll","assets/index-faq","assets/hero-index-video","assets/explainer-section"], () => (__webpack_require__("./src/scss/newsletter-footer.scss")))
/******/ 	__webpack_require__.O(undefined, ["assets/customer","assets/custom-collection-section","assets/cart-patch-integration","assets/app","assets/announcement-bar","assets/section-main-page-custom","assets/section-landing-page","assets/section-faq","assets/products-showcase","assets/product","assets/product-reviews","assets/patches-page","assets/patches-overlay","assets/patches-modal","assets/patch-subscribe-block","assets/partnership","assets/newsletter-footer","assets/newsletter-alternative","assets/new-cart-items","assets/live-search","assets/index-text-scroll","assets/index-faq","assets/hero-index-video","assets/explainer-section"], () => (__webpack_require__("./src/scss/partnership.scss")))
/******/ 	__webpack_require__.O(undefined, ["assets/customer","assets/custom-collection-section","assets/cart-patch-integration","assets/app","assets/announcement-bar","assets/section-main-page-custom","assets/section-landing-page","assets/section-faq","assets/products-showcase","assets/product","assets/product-reviews","assets/patches-page","assets/patches-overlay","assets/patches-modal","assets/patch-subscribe-block","assets/partnership","assets/newsletter-footer","assets/newsletter-alternative","assets/new-cart-items","assets/live-search","assets/index-text-scroll","assets/index-faq","assets/hero-index-video","assets/explainer-section"], () => (__webpack_require__("./src/scss/patch-subscribe-block.scss")))
/******/ 	__webpack_require__.O(undefined, ["assets/customer","assets/custom-collection-section","assets/cart-patch-integration","assets/app","assets/announcement-bar","assets/section-main-page-custom","assets/section-landing-page","assets/section-faq","assets/products-showcase","assets/product","assets/product-reviews","assets/patches-page","assets/patches-overlay","assets/patches-modal","assets/patch-subscribe-block","assets/partnership","assets/newsletter-footer","assets/newsletter-alternative","assets/new-cart-items","assets/live-search","assets/index-text-scroll","assets/index-faq","assets/hero-index-video","assets/explainer-section"], () => (__webpack_require__("./src/scss/patches-modal.scss")))
/******/ 	__webpack_require__.O(undefined, ["assets/customer","assets/custom-collection-section","assets/cart-patch-integration","assets/app","assets/announcement-bar","assets/section-main-page-custom","assets/section-landing-page","assets/section-faq","assets/products-showcase","assets/product","assets/product-reviews","assets/patches-page","assets/patches-overlay","assets/patches-modal","assets/patch-subscribe-block","assets/partnership","assets/newsletter-footer","assets/newsletter-alternative","assets/new-cart-items","assets/live-search","assets/index-text-scroll","assets/index-faq","assets/hero-index-video","assets/explainer-section"], () => (__webpack_require__("./src/scss/patches-overlay.scss")))
/******/ 	__webpack_require__.O(undefined, ["assets/customer","assets/custom-collection-section","assets/cart-patch-integration","assets/app","assets/announcement-bar","assets/section-main-page-custom","assets/section-landing-page","assets/section-faq","assets/products-showcase","assets/product","assets/product-reviews","assets/patches-page","assets/patches-overlay","assets/patches-modal","assets/patch-subscribe-block","assets/partnership","assets/newsletter-footer","assets/newsletter-alternative","assets/new-cart-items","assets/live-search","assets/index-text-scroll","assets/index-faq","assets/hero-index-video","assets/explainer-section"], () => (__webpack_require__("./src/scss/patches-page.scss")))
/******/ 	__webpack_require__.O(undefined, ["assets/customer","assets/custom-collection-section","assets/cart-patch-integration","assets/app","assets/announcement-bar","assets/section-main-page-custom","assets/section-landing-page","assets/section-faq","assets/products-showcase","assets/product","assets/product-reviews","assets/patches-page","assets/patches-overlay","assets/patches-modal","assets/patch-subscribe-block","assets/partnership","assets/newsletter-footer","assets/newsletter-alternative","assets/new-cart-items","assets/live-search","assets/index-text-scroll","assets/index-faq","assets/hero-index-video","assets/explainer-section"], () => (__webpack_require__("./src/scss/product-reviews.scss")))
/******/ 	__webpack_require__.O(undefined, ["assets/customer","assets/custom-collection-section","assets/cart-patch-integration","assets/app","assets/announcement-bar","assets/section-main-page-custom","assets/section-landing-page","assets/section-faq","assets/products-showcase","assets/product","assets/product-reviews","assets/patches-page","assets/patches-overlay","assets/patches-modal","assets/patch-subscribe-block","assets/partnership","assets/newsletter-footer","assets/newsletter-alternative","assets/new-cart-items","assets/live-search","assets/index-text-scroll","assets/index-faq","assets/hero-index-video","assets/explainer-section"], () => (__webpack_require__("./src/scss/product.scss")))
/******/ 	__webpack_require__.O(undefined, ["assets/customer","assets/custom-collection-section","assets/cart-patch-integration","assets/app","assets/announcement-bar","assets/section-main-page-custom","assets/section-landing-page","assets/section-faq","assets/products-showcase","assets/product","assets/product-reviews","assets/patches-page","assets/patches-overlay","assets/patches-modal","assets/patch-subscribe-block","assets/partnership","assets/newsletter-footer","assets/newsletter-alternative","assets/new-cart-items","assets/live-search","assets/index-text-scroll","assets/index-faq","assets/hero-index-video","assets/explainer-section"], () => (__webpack_require__("./src/scss/products-showcase.scss")))
/******/ 	__webpack_require__.O(undefined, ["assets/customer","assets/custom-collection-section","assets/cart-patch-integration","assets/app","assets/announcement-bar","assets/section-main-page-custom","assets/section-landing-page","assets/section-faq","assets/products-showcase","assets/product","assets/product-reviews","assets/patches-page","assets/patches-overlay","assets/patches-modal","assets/patch-subscribe-block","assets/partnership","assets/newsletter-footer","assets/newsletter-alternative","assets/new-cart-items","assets/live-search","assets/index-text-scroll","assets/index-faq","assets/hero-index-video","assets/explainer-section"], () => (__webpack_require__("./src/scss/section-faq.scss")))
/******/ 	__webpack_require__.O(undefined, ["assets/customer","assets/custom-collection-section","assets/cart-patch-integration","assets/app","assets/announcement-bar","assets/section-main-page-custom","assets/section-landing-page","assets/section-faq","assets/products-showcase","assets/product","assets/product-reviews","assets/patches-page","assets/patches-overlay","assets/patches-modal","assets/patch-subscribe-block","assets/partnership","assets/newsletter-footer","assets/newsletter-alternative","assets/new-cart-items","assets/live-search","assets/index-text-scroll","assets/index-faq","assets/hero-index-video","assets/explainer-section"], () => (__webpack_require__("./src/scss/section-landing-page.scss")))
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["assets/customer","assets/custom-collection-section","assets/cart-patch-integration","assets/app","assets/announcement-bar","assets/section-main-page-custom","assets/section-landing-page","assets/section-faq","assets/products-showcase","assets/product","assets/product-reviews","assets/patches-page","assets/patches-overlay","assets/patches-modal","assets/patch-subscribe-block","assets/partnership","assets/newsletter-footer","assets/newsletter-alternative","assets/new-cart-items","assets/live-search","assets/index-text-scroll","assets/index-faq","assets/hero-index-video","assets/explainer-section"], () => (__webpack_require__("./src/scss/section-main-page-custom.scss")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;